/**
 * Material- und Rahmenbibliothek aus dem Admin (`GET {editorBaseUrl}/preview3d/library`).
 * Einmal pro Seite geladen; ohne Antwort gelten die eingebauten Standards.
 */
import { BUILTIN_LIBRARY, mergeLibrary } from './defaults.ts'
import type { Preview3dLibrary } from './types.ts'

let pending: Promise<Preview3dLibrary> | null = null
let pendingBase = ''

export function loadPreview3dLibrary(editorBaseUrl: string): Promise<Preview3dLibrary> {
  const base = String(editorBaseUrl || '').trim().replace(/\/+$/, '')
  if (pending && pendingBase === base) return pending
  pendingBase = base
  pending = (async () => {
    if (!base) return BUILTIN_LIBRARY
    try {
      const res = await fetch(`${base}/preview3d/library`, { headers: { Accept: 'application/json' } })
      if (!res.ok) return BUILTIN_LIBRARY
      const data = await res.json()
      return mergeLibrary(data)
    } catch {
      return BUILTIN_LIBRARY
    }
  })()
  return pending
}

/** Nach Änderungen im Admin (Live-Vorschau) neu laden */
export function resetPreview3dLibrary() {
  pending = null
}
